import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { PageHeader, Loading, Empty } from "../components/Layout";
import { StatusChip } from "../components/Badges";
import { Building2 } from "lucide-react";

export default function Accounts() {
  const [accts, setAccts] = useState(null);
  const nav = useNavigate();
  useEffect(() => { api.get("/accounts").then((r) => setAccts(r.data)); }, []);

  if (!accts) return (<><PageHeader eyebrow="MULTI-THREAD MODEL" title="Accounts" hint="Every company you sell to. Deal value and account status live here; leads are the people inside each account. Click an account to see all its leads." /><div className="p-8"><Loading /></div></>);

  return (
    <>
      <PageHeader eyebrow="MULTI-THREAD MODEL · DEAL VALUE LIVES HERE" title="Accounts" hint="Every company you sell to. Deal value and account status live here; leads are the people inside each account. Click an account to see all its leads." right={<span className="font-mono text-xs text-[#1C2530]/50">{accts.length} ACCOUNTS</span>} />
      <div className="p-8">
        {accts.length === 0 ? (
          <div className="flex flex-col items-center justify-center text-center py-24" data-testid="accounts-empty">
            <h2 className="text-2xl font-light text-[#1C2530] mb-2">No accounts yet</h2>
            <p className="text-base text-[#1C2530]/55 max-w-md mb-6">Accounts appear as you add companies and leads. Import your list to populate them automatically.</p>
            <button onClick={() => nav("/import")} data-testid="accounts-empty-import" className="bg-[#1C2530] text-[#F5F3EE] px-5 py-2.5 text-sm rounded-full hover:bg-[#2a3644] transition-colors">Import leads</button>
          </div>
        ) : (
          <div className="border border-[#DFDAD0] bg-white" data-testid="accounts-table">
            <table className="w-full text-sm">
              <thead>
                <tr className="bg-[#EFECE5] font-mono text-[10px] uppercase tracking-wider text-[#1C2530]/60">
                  <th className="text-left px-4 py-2.5">Account</th>
                  <th className="text-left px-4 py-2.5">Industry</th>
                  <th className="text-left px-4 py-2.5">Geography</th>
                  <th className="text-right px-4 py-2.5">Contacts</th>
                  <th className="text-right px-4 py-2.5">Leads</th>
                  <th className="text-right px-4 py-2.5">Deal Value</th>
                  <th className="text-left px-4 py-2.5">Status</th>
                </tr>
              </thead>
              <tbody>
                {accts.map((a, i) => (
                  <tr key={a.id} onClick={() => nav(`/accounts/${a.id}`)} data-testid={`account-row-${a.id}`}
                    className={`cursor-pointer hover:bg-[#EFECE5] border-t border-[#DFDAD0] ${i % 2 ? "bg-[#F5F3EE]/40" : "bg-white"}`}>
                    <td className="px-4 py-2.5 font-medium text-[#1C2530] flex items-center gap-2">
                      <Building2 className="w-4 h-4 text-[#1C2530]/40" strokeWidth={1.5} />{a.name}
                    </td>
                    <td className="px-4 py-2.5 text-[#1C2530]/70">{a.industry}</td>
                    <td className="px-4 py-2.5 text-[#1C2530]/70">{a.geography}</td>
                    <td className="px-4 py-2.5 text-right font-mono tabular-nums">{a.contact_count}</td>
                    <td className="px-4 py-2.5 text-right font-mono tabular-nums">{a.lead_count}</td>
                    <td className="px-4 py-2.5 text-right font-mono tabular-nums">${a.deal_value.toLocaleString()}</td>
                    <td className="px-4 py-2.5"><StatusChip status={a.status} /></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </>
  );
}
